/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_DurationInputs */

const cs_form_duration = /** @type {(inputs: Form_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trvání`)
};

const en_form_duration = /** @type {(inputs: Form_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration`)
};

/**
* | output |
* | --- |
* | "Duration" |
*
* @param {Form_DurationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_duration = /** @type {((inputs?: Form_DurationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_DurationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_duration(inputs)
	return cs_form_duration(inputs)
});